<template>
  <button
    class="bg-transparent hover:bg-blue-400 text-blue-700 font-semibold hover:text-white py-2 px-4 mt-3 w-full text-sm border border-blue-500 hover:border-transparent rounded-xl disabled:hover:bg-transparent disabled:border-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed"
    type="button"
    :onclick="onSendCode"
    :disabled="isDisabled"
  >
    ENVIAR NOVO CÓDIGO
  </button>
</template>

<script lang="ts">
import { defineComponent, ref, onBeforeUnmount } from 'vue';

export default defineComponent({
  name: 'ButtonSendCode',
  props: {
    sendCode: {
      type: Function,
      default: () => null,
    },
  },
  setup(props) {
    const isDisabled = ref(false);
    let intervalId: number;

    const disabledButton = () => (isDisabled.value = true);

    const enabledButton = () => (isDisabled.value = false);

    const onSendCode = () => {
      props.sendCode();
      disabledButton();
      intervalId = setInterval(() => {
        enabledButton();
      }, 5000);
    };

    onBeforeUnmount(() => {
      clearInterval(intervalId);
    });

    return {
      isDisabled,
      onSendCode,
    };
  },
});
</script>
